'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postClearPageTitleNotification = undefined;

var _createPostMessageAction = require('../../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../../constants/PostMessageTypes');

var postClearPageTitleNotification = exports.postClearPageTitleNotification = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.CLEAR_PAGE_TITLE_NOTIFICATION);